import { graphql } from 'react-relay';
import { queryInterop } from '@confluence/apollo-relay-interop/entry-points/query.ts';

import {
	type fetchPresenceConfluenceUsersQuery as UsersQuery$data,
	type fetchPresenceConfluenceUsersQueryVariables as UsersQuery$variables,
} from './__types__/FetchPresenceConfluenceUsersQuery.ts';

export const fetchPresenceConfluenceUsers = (accountIds: string[]) => {
	return queryInterop<UsersQuery$data, UsersQuery$variables>({
		query: graphql`
			query fetchPresenceConfluenceUsersQuery($accountIds: [String]) {
				confluenceUsers(accountIds: $accountIds) {
					nodes {
						profilePicture {
							isDefault
							path(type: RELATIVE)
						}
						... on KnownUser {
							accountId
						}
						... on UnknownUser {
							accountId
						}
						displayName
					}
				}
			}
		`,
		variables: {
			accountIds,
		},
	}).then(({ data }) => {
		return (
			data?.confluenceUsers?.nodes
				?.filter((user) => (user as any)?.accountId)
				.map((user) => ({
					avatar: user?.profilePicture?.path ?? '',
					email: '',
					isGuest: undefined,
					name: user?.displayName ?? '',
					userId: (user as any)?.accountId ?? '',
				})) ?? []
		);
	});
};
